export default "__VITE_ASSET__baf68cd1__"